import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconEyeOpen = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24" fill="currentColor">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.9285 11.628C19.8365 11.399 17.6115 6 11.9995 6C6.3875 6 4.1625 11.399 4.0705 11.628C3.9765 11.867 3.9765 12.133 4.0705 12.372C4.1625 12.601 6.3875 18 11.9995 18C17.6115 18 19.8365 12.601 19.9285 12.372C20.0225 12.133 20.0225 11.867 19.9285 11.628ZM11.9995 16C9.7905 16 7.9995 14.209 7.9995 12C7.9995 9.791 9.7905 8 11.9995 8C14.2095 8 15.9995 9.791 15.9995 12C15.9995 14.209 14.2095 16 11.9995 16ZM11.9995 10C10.8955 10 9.9995 10.896 9.9995 12C9.9995 13.104 10.8955 14 11.9995 14C13.1045 14 13.9995 13.104 13.9995 12C13.9995 10.896 13.1045 10 11.9995 10Z"
      fill="currentColor"
    />
  </SvgIcon>
)
